import React from "react";
import { Button } from "armstrong-react";

interface Props {
  /**
   * Icomoon string
   */
  leftIcon: string;

  className?: string;

  onClick: () => void|Promise<any>;

  style?: React.CSSProperties;
}

/**
 * Wrapper for armstrong button which sets pending state when action is called
 */
export default class PendingButton extends React.Component<Props, any> {
  private handleClick = () => {
    this.setState({ isPending: true }, async () => {
      await this.props.onClick();
      this.setState({ isPending: false });
    });
  }

  public render() {
    return <Button className={this.props.className} style={this.props.style} leftIcon={this.props.leftIcon} onClick={this.handleClick}>{this.props.children}</Button>
  }
}